const handleUpdateCharacterPreview = (result, characterCreatorState, setCharacterCreatorState) =>{
    let tempCharacterCreatorState = {...characterCreatorState}
    tempCharacterCreatorState.characterPreviewImageId = JSON.parse(JSON.stringify(result.generations_by_pk.generated_images[0].id))
    tempCharacterCreatorState.characterPreview = JSON.parse(JSON.stringify(result.generations_by_pk.generated_images[0].url))
    setCharacterCreatorState(tempCharacterCreatorState)
}

export default handleUpdateCharacterPreview